import { DecimalPipe, NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { MatProgressBarModule } from '@angular/material/progress-bar';

import { TranslocoRootModule } from '@eai-tdv/core/transloco';

import { formatBytes } from '@eai-tdv/shared/functions';
import { IconComponent } from '@eai-tdv/shared/icon';

import { IUploadResourceItem } from '../../upload-resource.types';

@Component({
  imports: [
    NgClass,
    MatProgressBarModule,
    NgIf,
    IconComponent,
    DecimalPipe,
    TranslocoRootModule,
  ],
  selector: 'tdv-upload-resource-progress-total',
  templateUrl: './upload-resource-progress-total.component.html',
  styleUrls: ['./upload-resource-progress-total.component.scss'],
})
export class UploadResourceProgressTotalComponent {
  @Input({ required: true }) public set items(
    list: Array<IUploadResourceItem>,
  ) {
    this.calculateProgress(list || []);
  }

  public totalSize?: number;
  public uploadedSize?: number;
  public totalProgressPercent?: number;
  public isMultiUpload?: boolean;
  public sizeType?: string;
  public isAllLoaded?: boolean;

  private calculateProgress(list: Array<IUploadResourceItem>): void {
    this.isMultiUpload = list.length > 1;
    const totalSizeByte = list.reduce((acc, i) => acc + i.uploadSizeBytes, 0);
    const uploadedSizeByte = list.reduce(
      (acc, i) =>
        acc + i.uploadSizeBytes * (i.progressForUploadBlobWatcher.value / 100),
      0,
    );
    const sizeData = formatBytes(totalSizeByte);
    this.sizeType = sizeData.type;
    this.totalSize = sizeData.size;
    this.totalProgressPercent = (uploadedSizeByte / totalSizeByte) * 100;
    this.uploadedSize = (sizeData.size * this.totalProgressPercent) / 100;
    this.isAllLoaded =
      list.length ===
      list.filter(i => i.progressForUploadBlobWatcher.value === 100).length;
  }
}
